import { DefaultTheme } from 'styled-components';

import { commonThemeData, defaultPalette, themeTypography } from './themeData';

export const defaultTheme: DefaultTheme = {
  ...themeTypography,
  ...defaultPalette,
  ...commonThemeData,
};
